import { Component, inject, input, OnDestroy, OnInit, output, signal } from '@angular/core';
import { RidBottomButton } from '../../components/rid-bottom-button/rid-bottom-button';
import { RidButton } from '../../components/rid-button/rid-button';
import { RidFeedbackToast } from '../../components/rid-feedback-toast/rid-feedback-toast';
import { RidHorizontalPages } from '../../components/rid-horizontal-pages/rid-horizontal-pages';
import { RidInstructionModal } from '../../components/rid-instruction-modal/rid-instruction-modal';
import { RidMechanicBackground } from '../../components/rid-mechanic-background/rid-mechanic-background';
import { RidMechanicContent } from '../../components/rid-mechanic-content/rid-mechanic-content';
import { RidMechanicTitle } from '../../components/rid-mechanic-title/rid-mechanic-title';
import { RidMechanicWrapper } from '../../components/rid-mechanic-wrapper/rid-mechanic-wrapper';
import { RidModalBackground } from '../../components/rid-modal-background/rid-modal-background';
import { RidRatingModal } from '../../components/rid-rating-modal/rid-rating-modal';
import { RidTopBar } from '../../components/rid-top-bar/rid-top-bar';
import { RidWordMatrix } from '../../components/rid-word-matrix/rid-word-matrix';
import { PluralPipe } from '../../pipes/plural.pipe';
import { DiceService } from '../../services/dice-service.service';

@Component({
  selector: 'rid-reading-matrix-stopwatch',
  imports: [
    PluralPipe,
    RidButton,
    RidTopBar,
    RidMechanicBackground,
    RidRatingModal,
    RidFeedbackToast,
    RidInstructionModal,
    RidMechanicTitle,
    RidMechanicWrapper,
    RidMechanicContent,
    RidModalBackground,
    RidBottomButton,
    RidHorizontalPages,
    RidWordMatrix,
  ],
  templateUrl: './rid-reading-matrix-stopwatch.html',
  host: {
    class: 'block',
  },
})
export class RidReadingMatrixStopwatch implements OnInit, OnDestroy {
  private readonly $diceService = inject(DiceService);

  matrices = input.required<string[][][]>();
  previousDuration = input<number>();

  index = signal(0);
  state = signal<
    { type: 'INSTRUCTION' } | { type: 'READING' } | { type: 'FEEDBACK'; duration: number } | { type: 'RATING' } | { type: 'VIEWING' }
  >({
    type: 'INSTRUCTION',
  });

  finished = output<{ duration: number | undefined }>();

  startTime = new Date();
  endTime: Date | undefined;
  duration: number | undefined;

  ngOnInit(): void {
    this.$diceService.isNumericDiceAvailable.set(true);
  }

  ngOnDestroy(): void {
    this.$diceService.isNumericDiceAvailable.set(false);
  }

  start() {
    this.startTime = new Date();
    this.state.set({ type: 'READING' });
  }

  finishReading() {
    this.endTime = new Date();
    this.duration = this.endTime.getTime() - this.startTime.getTime();
    this.state.set({ type: 'FEEDBACK', duration: Math.round(this.duration / 1000) });
  }

  finish() {
    this.finished.emit({ duration: this.duration });
  }
}
